import { getClient } from "lib/apolloClient"
import { EMAIL_CONTACT } from "data/general/gql"

export const registerContact = async (params: {
  email: string
  country: string
  source: string
}): Promise<boolean> => {
  try {
    const { data } = await getClient().query({
      query: EMAIL_CONTACT,
      variables: {
        ...params,
      },
    })

    const isSuccessful = data?.addEmailContact.isSuccessful

    return Promise.resolve(isSuccessful)
  } catch (err) {
    return Promise.resolve(false)
  }
}
